<template>
  <div class="image-modal">
    <ModalPortal @close="emits('close')">
      <template #body>
        <div v-if="!imageLoaded" class="image-modal__loader">
          <CSpinner />
        </div>

        <CImage
          :src="variant.images"
          :alt="variant.name"
          :width="modalImageSize"
          :height="modalImageSize"
          :params="{ w: modalImageSize, h: modalImageSize, fit: 'contain' }"
          @image-is-lazy-loaded="setImageLoaded"
          @fallback-image="setImageLoaded"
        />
        <span v-if="imageLoaded && variant.articleNumber" class="image-modal__art-nr">
          {{ t('article_number') }}:
          <span>{{ variant.articleNumber }}</span>
        </span>
      </template>
    </ModalPortal>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Variant } from '@/types/products';

type Props = {
  variant?: Variant;
};

const { variant } = withDefaults(defineProps<Props>(), {
  variant: () => {},
});
const emits = defineEmits<{
  (e: 'close', event?: Boolean): void;
}>();

const { t } = useI18n();
const { mq } = useMediaQueries();

const imageLoaded = ref(false);
const modalImageSize = computed(() => {
  return mq.value.xsmall ? '272' : '352';
});

const setImageLoaded = () => {
  imageLoaded.value = true;
};
</script>

<script lang="ts">
export default defineComponent({
  name: 'ImageModal',
});
</script>

<style lang="scss">
.image-modal {
  &__art-nr {
    @apply text-gray-800;
    margin-top: 24px;
    font-size: 12px;
    display: block;
    width: 100%;
    > span {
      @apply font-bold;
    }
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
  }
}
</style>
